// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"416":"5b268a16","900":"2f787f4b"}[chunkId] + ".css";
};